import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot} from '@angular/router';

@Injectable()
export class ProjectsMenuResolve {
    resolve(route: ActivatedRouteSnapshot) {
        return 'project' + route.params['projectId'];
    }
}
